export default "__VITE_PUBLIC_ASSET__f8ed6c0b__"